"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertSVGtoBase64 = function (svgContents) {
    return Buffer.from(svgContents.replace("<svg", '<svg style="background-color: #fff;"')).toString("base64");
};
exports.default = convertSVGtoBase64;
